import {
  Slider as ChakraSlider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb,
  Flex
} from "@chakra-ui/react";

export default function Slider({
  min,
  max,
  step,
  onChange,
  onChangeEnd,
  value,
  orientation = "horizontal",
  props,
  ...rest
}) {
  return (
    <Flex align="center" w="100%" {...rest}>
      <ChakraSlider
        aria-label="slider"
        min={min}
        max={max}
        onChange={onChange}
        step={step}
        onChangeEnd={onChangeEnd}
        value={value}
        {...props}
        orientation={orientation}
      >
        <SliderTrack>
          <SliderFilledTrack />
        </SliderTrack>
        <SliderThumb />
      </ChakraSlider>
    </Flex>
  );
}
